<template>
  <span v-if="compra.valorMoedaConvertido.saving > 0">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon :class="smallClass"
                v-on="on"
                color="success">
          {{ icon }}
        </v-icon>
      </template>
      <span>
        <div class="text-center">
          {{ compra.valorMoedaConvertido.saving | currency }}<br>
          ({{ percentualSaving | number('0.00') }}%)
        </div>
      </span>
    </v-tooltip>
  </span>
</template>
<script>
import currency from 'currency.js';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'mdi-currency-brl',
    },
  },
  computed: {
    smallClass() {
      return this.small ? 'small' : '';
    },
    percentualSaving() {
      if (!this.compra.valorMoedaConvertido.saving) {
        return null;
      }
      return currency(this.compra.valorMoedaConvertido.saving).multiply(100)
        .divide(currency(this.compra.valorMoedaConvertido.total)
          .add(this.compra.valorMoedaConvertido.saving))
        .value;
    },
  },
};
</script>
<style scoped>
.small {
  font-size: 18px;
}
</style>
